<template>
<!-- FINAL ICARE -->
  <form @submit.prevent>
     <CModal
        :title.sync="title" 
        color="info"
        :closeOnBackdrop ="false"
        :show.sync="show">
        <CRow>
          <CCol>
            <CInput v-model="form.label"  label="Label"   />
            <CInput v-model="form.address1"  label="Primary Address"   />
            <CInput v-model="form.address2"  label="Secondary Address"   />
            <br>
              <label>Search City, State, Country</label>
              <!-- <v-select v-model="selected" :options="options" :reduce="op => op.label" @search="onSearch"> -->
              <v-select v-model="selected" :filterable="false" :options="options" @search="onSearch" @input="setSelected" label="a">
                <template slot="option" slot-scope="option">
                      <div><b>{{ option.city_name }}</b></div>
                      <div>{{ option.state_name + ' , ' + option.country_name}}</div>
                      <!-- <div><b>{{ option.label }}</b></div> 
                    <p style="font-size:100%;">{{ option.label_state + ' - ' + option.label_country }}</p>  -->
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div>{{ option.city_name + ', ' + option.state_name + ', ' + option.country_name}}</div>
                </template>
              </v-select>  

            <CInput v-model="form.city"  label="City" />
            <CInput v-model="form.state"  label="State" />
            <CInput v-model="form.country"  label="Country" />
            <CInput v-model="form.zipcode"  label="Zipcode" />
          
          </CCol> 
          </CRow>
       
        <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  v-if="mode === 'create'" type="submit" v-on:click.prevent="create(p_id)"  variant="outline" color="info">Create</CButton>
        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="update(form.id)"  variant="outline" color="info">Update</CButton>
       <!-- <pre>{{ $data | json }}</pre> -->
        </template>
    </CModal>
  </form>
</template>
<script>
import EventBus from '@/eventBus';

import member from '@/services/member';
import people from '@/services/people';
import satelite from '@/services/satelitechurch'
import icare from '@/services/icare'

import setting from '@/services/setting';

import moment from 'moment'

export default {
name: 'covenantmodal',
  data () {
    return {
    search_value:'',
    show: false,
    title: 'Default Title',
    mode: '',
    p_id:'',
    form:{
      id:'',
      label:'',
      address1:'',
      address2:'',
      city:'',
      state:'',
      country:'',
      zipcode:'',
    },
    selected:'',
    options: []
    }
  },

  mounted (){
     
   },
  
  created () {
    var self = this; 
      EventBus.$on('OPEN_MODAL_MULTIPLE_ADDRESS', (params) => {
      if(params.data){
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;

        if(self.mode == 'create'){
          self.p_id = params.data;
          self.form.label = "";
          self.form.address1 = "";
          self.form.address2 = "";
          self.form.city = "";
          self.form.state = "";
          self.form.country = "";
          self.form.zipcode = "";
          self.options=[];
          self.selected='';
        }else if(self.mode == 'edit'){
          people.get_address(params.data)
          .then(res => {
            self.form.id = res.data.id;
            self.form.label = res.data.label;
            self.form.address1 = res.data.address1;
            self.form.address2 = res.data.address2;
            self.form.city = res.data.city;
            self.form.state = res.data.state;
            self.form.country = res.data.country;
            self.form.zipcode = res.data.zipcode;
            self.options=[];
            self.selected='';
          }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          })
        }

        this.search(true, '', this); 


      }
    });
    
  },
  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    create(id){
      this.show = false;
      people.add_address(id, this.form)
      .then(res => {
        EventBus.$emit('PAGE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
    update(id){
      this.show = false;
      people.update_address(id, this.form)
      .then(res => {
        EventBus.$emit('PAGE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
    
    onSearch(search, loading) {
      //if(search.length) {
        loading(true);
        this.search(loading, search, this);
      //}
    },
    search: _.debounce((loading, search, vm) => {
      fetch(
        process.env.VUE_APP_URL + `/world/place?search=${escape(search)}`
      ).then(res => {
        res.json().then(json => (vm.options = json.data));
        loading(false);
      });
    }, 350),

    setSelected(value) {
      //this.selected = value.city_name
      this.form.city = value.city_name
      this.form.state = value.state_name
      this.form.country = value.country_name
    }

  }
}
</script>

<style>

</style>